const shippingTime = (rawData) => {
    if (!rawData.extension_attributes?.shipping_time) return null;

    const shippingTime = rawData.extension_attributes.shipping_time;

    return shippingTime * 1000;
}

export function normalizeCart(rawData) {

    rawData.subTotal = rawData?.totals_info?.subtotal_with_discount ?? 0;
    rawData.base_grand_total = rawData?.totals_info?.base_grand_total ?? 0;

    rawData.couponCode = rawData?.totals_info ? (rawData?.totals_info?.coupon_code || null) : null;
    rawData.items = rawData?.items ? rawData.items.map((itemData, i) => {
        let itemTotals = rawData?.totals?.items[i] || rawData?.totals_info?.items[i] || {};
        try {
            return {
                item_id: itemData.item_id,
                sku: itemData.sku,
                name: itemData.name,
                price: parseFloat(itemData.price).toFixed(2),
                price_incl_tax: parseFloat(itemTotals?.price_incl_tax || itemData.price).toFixed(2),
                //price_incl_tax: parseFloat(.price_incl_tax).toFixed(2) || null,
                qty: itemData.qty,
                ...itemTotals,
                product_id: itemData.extension_attributes?.product_id || null,
                image: itemData.extension_attributes?.image || null,
                options: itemTotals.options ? JSON.parse(itemTotals.options) : [],
                url: itemData.extension_attributes?.url || null,

                hide_options: itemData.extension_attributes?.hide_options || [],

            };
        } catch (e) {
            console.error('error normalizer', e);
            return null;
        }

    }) : [];
    rawData.billing_address = normalizeCartAddress(rawData.billing_address) || null;
    rawData.shipping_address = rawData?.extension_attributes?.shipping_assignments.length > 0 ? normalizeCartAddress(rawData?.extension_attributes?.shipping_assignments[0].shipping?.address) || null : null;

    rawData.deliveryTime = rawData.extension_attributes?.delivery_time ? rawData.extension_attributes?.delivery_time : null;
    rawData.shippingTime = shippingTime(rawData);
    rawData.totals = normalizeCartTotals(rawData.totals_info);
    rawData.couponCode = rawData.totals_info ? rawData.totals_info.coupon_code : null;

    return rawData;
}


// address
export function normalizeCartAddress(rawData) {

    if (!rawData) return null;

    return {
        ...rawData,
        company: rawData?.company || '',
        pec: rawData?.extension_attributes?.pec || '',
        sdi: rawData?.extension_attributes?.sdi || '',
        invoice_request: rawData?.extension_attributes?.invoice_request == '1' ? '1' : '0',
        same_as_billing: rawData?.same_as_billing ,
        fiscal_code: rawData?.extension_attributes?.fiscal_code || '',
    };
}

export function normalizeCartItems(rawData, rawTotalsItems) {
    return rawData.map((r, i) => normalizeCartItem(r, rawTotalsItems[i]));
}

export function normalizeCartItem(rawData, rawTotals) {

    let totalsInfo = rawTotals || {};
    /*    if(rawTotals)
            totalsInfo = rawTotals.items.find(i => i.item_id = rawData.item_id) || {};*/
    try {
        return {
            item_id: rawData.item_id,
            sku: rawData.sku,
            name: rawData.name,
            price: parseFloat(rawData.price).toFixed(2),
            //price_incl_tax: parseFloat(rawData.price_incl_tax).toFixed(2),
            //price_incl_tax: parseFloat(.price_incl_tax).toFixed(2) || null,
            qty: rawData.qty,
            image: rawData.extension_attributes?.image || null,
            product_id: rawData.extension_attributes?.product_id || null,
            options: rawData.options ? JSON.parse(rawData.options) : [],
            //options_info: rawData.extension_attributes?.custom_option_info || null,
            ...totalsInfo
        };
    } catch (e) {
        console.error('error normalizer', e);
        return null;
    }
}

export function normalizeCartTotals(rawData) {
    return rawData;
}

export function normalizeCartPaymentMethods(rawData) {
    return rawData;
}